import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../../lib/net";
import Fr_Input from "../../../lib/ui/fr_input";
import Fr_Select from "../../../lib/ui/fr_select";
import Vip_Trs from "./vip_trs";

class Vip_Fkn extends React.Component {
  constructor(props, context) {
    super(props);

    this.pos = props.store.pos;
    this.state = {};
    this.state.ynq = [];
    this.state.sval = [];

    this.state.dao = {};
    this.state.aa = [];
    this.state.kta = [];
    this.state.cval = [
                {id: '001', text: 'ANTAL GER NYTT PRIS'},
                {id: '002', text: 'ANTAL GER RABATT PÅ PRIS'},
                {id: '003', text: 'PRISÄNDRING GENOM RABATT'}
            ];

    this.state.wnds = {};
    this.state.vpo = props.vpo;
    this.state.kta = props.wnds.kta;
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    //this.happy();
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    tab_style(tabid) {
      var css = {};
      css.display = "none";
      if(this.state.tabval === tabid) css.display = "block";
      return css;
    }
    tab_head(tabid) {
      var css = {};
      css.background = "#fff";
      css.color = "#000";
      if(this.state.tabval === tabid) {
          css.background = "#080";
          css.color = "#fff";
      }
      return css;
    }
    grp_style(row) {
      var css = {};
      css.background = "#008";
      if(this.state.gnr === row.vgrupp) css.background = "#080";
      return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
		this.props.ctx.setState({ wnds: {} });
	};
    handleChange = (event, newValue) => {
        //alert(newValue);
        this.setState({ix: newValue});
      };
    toggle() {
      this.setState({modal: false});
	};

  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  vip_read() {
    var self = this;
    var prm = {};
    prm.req = "vip.vip_reg.vip_read";
    prm.avd = this.state.pbo.plu00.p0kstns;
    prm.plu = this.state.pbo.plu00.p0katnr;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        self.setState({hap: ret.rco }, function() { this.cdi_init(); });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  vip_save() {
    var self = this;

    //this.cdi_store();

    var prm = {};
      prm.req = "vip.vip_reg.reg_upd";
      prm.vpo = this.state.vpo;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

		self.props.ctx.setState({ wnds: {} });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
    vip_import() {
        var self = this;

        var prm = {};
        prm.req = "vip.vip_reg.vip_import";
        prm.vpo = this.state.vpo;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret));
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
    vip_gen() {
        var self = this;

        var prm = {};
        prm.req = "vip.vip_reg.vip_gen";
        prm.vpo = this.state.vpo;

        net.sio_req(prm)
            .then(function(ret){
                //alert(JSON.stringify(ret));
            })
            .catch(function(e){
                var txt = JSON.stringify(e);
            });
    }
  val_get (name) {
      var value = "";
    //alert(JSON.stringify(name));
    //alert(JSON.stringify(value));
    var na = name.split(".");
    //var ff = na[1];
    var vpo = this.state.vpo;
    if(vpo) value = vpo[na[0]][na[1]];
    if(name == "vip02.v2kortnr") value = value.ztrim();
    if(name == "vip02.v2tillgodo") value = value.cdipris();
    if(name == "vip02.v2kredit") value = value.cdipris();
    return value;
   }
    val_set (name, value) {
        //alert(JSON.stringify(name));
        //alert(JSON.stringify(value));
        var na = name.split(".");
        var vpo = this.state.vpo;
        vpo[na[0]][na[1]] = value;
        this.setState({vpo: vpo});
    }

    vip_trs() {
        var self = this;
        var wnds = {};
        wnds.viptrs = 1;
        self.setState({ wnds: wnds, vpo: this.state.vpo });
    }
    vip_fkn(fkn) {
        var self = this;

        if(fkn == "gen") {
            self.vip_gen();
        }
        if(fkn == "import") {
            self.vip_import();
        }
    }

  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "Knappar";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_70 flex-col" style={ this.dlg_style() } >
        <div className="mx_h01">
            <div>FUNKTIONER</div>
        </div>
        <div className="mx_content flex">

            <div className="flex-row" style={{padding:"5px",height:"35px"}}>
                    <div className="flex-col flex">
                    </div>
                    <div className="flex-col">
                        <div>UPPDATERA</div>
                    </div>
            </div>
            <div className="divider_orange"></div>

            <div className="web-col flex" style={{padding: "0px 10px"}}>
                <div className="wnd-btn" onClick={() => this.vip_fkn("gen") } >
                    <div>GENERERA SERIE</div>
                    <div></div>
                </div>
                <div className="wnd-btn" onClick={() => this.vip_fkn("logg") } >
                    <div>INDEXERA OM</div>
                    <div></div>
                </div>
                <div className="wnd-btn" onClick={() => this.vip_fkn("import") } >
                    <div>IMPORTERA SERIE</div>
                    <div></div>
                </div>
            </div>

        </div>
        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <button className="btn btn-hw-green w250" onClick={() => this.vip_trs() } >
                FKNS
            </button>
            <button className="btn btn-hw-green w250" onClick={() => this.vip_save() } >
                SPARA
            </button>
        </div>
      </div>
        { this.state.wnds.viptrs ?
            <Vip_Trs wnds={this.state.wnds} ctx={this} vpo={this.state.vpo} store={this.props.store} backdrop={true}/>
        : null }
      </div>
	;
	return html;
  };
}

export default Vip_Fkn;